import { render, staticRenderFns } from "./RewardRuleList.vue?vue&type=template&id=edc3a250"
import script from "./RewardRuleList.vue?vue&type=script&lang=js"
export * from "./RewardRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports